import { STEP2_TAB } from '@/constants/ui/inspection/step2/tabs'

/** step2調査タブ */
export const STEP2_TAB_LABELS = {
  [STEP2_TAB.neighboring]: '隣接建築物・周辺地盤等および構造躯体',
  [STEP2_TAB.falling]: '落下危険物・転倒危険物'
} as const
